import React from 'react';
import './ErrorBoundary.css';
import { FiAlertOctagon, FiRefreshCw, FiHome } from 'react-icons/fi';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('EduSync Crash Report:', error, errorInfo);
  }

  handleRestart = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <div className="error-card">
            <div className="error-icon">
              <FiAlertOctagon />
            </div>
            <h1>We&apos;re sorry, but something went wrong.</h1>
            <p>
              An unexpected error occurred in the application. We&apos;ve logged the incident and
              are working on a fix.
            </p>
            {process.env.NODE_ENV !== 'production' && (
              <div className="error-details">
                <code>{this.state.error?.toString()}</code>
              </div>
            )}
            <div className="error-actions">
              <button onClick={this.handleRestart} className="btn-primary">
                <FiRefreshCw /> Try Again
              </button>
              <button onClick={this.handleGoHome} className="btn-secondary">
                <FiHome /> Back to Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

